//@flow

import {useSelector} from 'react-redux';
import {actions as toastActions} from '../duck';
import type {ToastAlert} from '../duck';
import type {RootState} from '../../';
import {useActions} from '../../../utils/globalStore';
import {useCallback} from 'react';

const toastSelector = (state: RootState) => state.toastAlert.toast;

export function useToast() {
  const toast = useSelector(toastSelector);

  return toast;
}

export function useToastActions() {
  const actions = useActions(toastActions);

  const showToast = useCallback(
    (toast: ToastAlert) => {
      actions.showToastAlert(toast);
    },
    [actions]
  );

  const closeToast = useCallback(() => {
    actions.closeToastAlert();
  }, [actions]);

  return {
    closeToast,
    showToast,
  };
}
